module.exports = __webpack_public_path__ + "static/media/goauto_logo.8620c377.svg";